import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Button, ThemeProvider, useMediaQuery } from '@mui/material';
import { Context } from '../../../context/UserContext';
import tableThemeCustom from '../../form/tableThemeCustom';
import styles from '../../form/Form.module.css';
import Form from './Form';
import { usePermissoesModule } from './modules/usePermissoesModule';
import { useCadastroModule } from './modules/useCadastroModule';
import { useArquivosModule } from './modules/useArquivosModule';
import { useRedacaoModule } from './modules/useRedacaoModule';
export default function CreateOrEdit({ tipo = false }) {
    const { parametro } = useContext(Context),
        location = useLocation();
    const permissoes = usePermissoesModule(tipo ? 'ArquivoDocumentoTipo' : 'ArquivoDocumento');
    const cadastro = useCadastroModule({ tipo, permissoes });
    const arquivos = useArquivosModule({
        documento: tipo ? {} : cadastro.salvos,
        permissoes,
        bloqueado: tipo || cadastro.isSubmitting || cadastro.carregando || cadastro.sujo || Boolean(cadastro.erro),
    });
    const redacao = useRedacaoModule({
        documento: tipo ? {} : cadastro.salvos,
        permissoes,
        arquivos,
        bloqueado: tipo || cadastro.isSubmitting || cadastro.carregando || cadastro.sujo || Boolean(cadastro.erro),
    });
    const theme = tableThemeCustom(),
        isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const abaInicial = new URLSearchParams(location.search).get('aba') === 'arquivos' ? 'arquivos' : 'cabecalho';
    if (!permissoes.autorizado) return <Alert severity={permissoes.pronto ? 'warning' : 'info'}>{permissoes.mensagem}</Alert>;
    if (cadastro.carregando) return <Alert severity="info">Carregando cadastro...</Alert>;
    if (cadastro.erro)
        return (
            <>
                <Alert severity="error">{cadastro.erro}</Alert>
                <Button onClick={cadastro.voltar}>Voltar</Button>
            </>
        );
    return (
        <ThemeProvider theme={theme}>
            <section className={`${styles.form_container} ${styles[parametro?.tema] || ''}`}>
                <Form
                    tipo={tipo}
                    cadastro={cadastro}
                    arquivos={arquivos}
                    redacao={redacao}
                    permissoes={permissoes}
                    parametro={parametro}
                    isMobile={isMobile}
                    abaInicial={abaInicial}
                />
            </section>
        </ThemeProvider>
    );
}
